import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "fields"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import { Box } from 'components/Flex';
import OverflowTooltip from 'components/OverflowTooltip';
import TextLink from 'components/TextLink';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx } from "react/jsx-runtime";
var UrlField = function UrlField(_ref) {
  var id = _ref.id,
    fields = _ref.fields,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var webUrl = fields.webUrl;
  return /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
    label: t('form_url_colon'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(OverflowTooltip, {
      content: webUrl.value,
      children: /*#__PURE__*/_jsx(Box, {
        grow: true,
        shrink: true,
        mr: "s",
        overflow: "ellipsis",
        children: /*#__PURE__*/_jsx(TextLink, {
          target: "_blank",
          href: webUrl.value,
          title: webUrl.value,
          children: webUrl.value
        })
      })
    })
  }));
};
export default UrlField;